import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { YieldLazyLoad } from "@devowl-wp/react-utils";
import { AsciiSpinner } from "../../asciiSpinner.js";
import { BANNER_GROUP_NON_STANDARD_STYLE } from "../body/body.js";
import { BannerTcfDeclarationList } from "./declarations/list.js";
import { BannerTcfVendorList } from "./vendors/list.js";
import { useBanner } from "../../../contexts/banner.js";
import { GroupButton } from "../../common/groupButton.js";
import { Group } from "../../common/groups/group.js";
import { GroupList } from "../../common/groups/groupList.js";
const DECLARATIONS = [
    "purposes",
    "specialPurposes",
    "features",
    "specialFeatures",
    "dataCategories"
];
const BannerTcfGroupList = ()=>{
    const banner = useBanner();
    const { tcfFilterBy, suspense, i18n: { legitimateInterest, consent, tcf: { filterText, standard, standardDesc } }, set } = banner;
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Group, {
                headline: standard,
                style: BANNER_GROUP_NON_STANDARD_STYLE,
                borderless: true,
                children: [
                    standardDesc,
                    /*#__PURE__*/ _jsxs("div", {
                        style: BANNER_GROUP_NON_STANDARD_STYLE,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                "aria-hidden": true,
                                children: filterText
                            }),
                            "\xa0",
                            /*#__PURE__*/ _jsx(GroupButton, {
                                legend: filterText,
                                active: tcfFilterBy,
                                onChange: (tcfFilterBy)=>set({
                                        tcfFilterBy: tcfFilterBy
                                    }),
                                items: [
                                    {
                                        key: "legInt",
                                        value: legitimateInterest
                                    },
                                    {
                                        key: "consent",
                                        value: consent
                                    }
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(YieldLazyLoad, {
                promise: suspense.lazyLoadedDataForSecondView,
                suspenseProbs: {
                    fallback: /*#__PURE__*/ _jsx(AsciiSpinner, {})
                },
                children: /*#__PURE__*/ _jsxs(GroupList, {
                    children: [
                        /*#__PURE__*/ _jsx(BannerTcfVendorList, {}),
                        DECLARATIONS.map((declaration)=>/*#__PURE__*/ _jsx(BannerTcfDeclarationList, {
                                declaration: declaration
                            }, declaration))
                    ]
                })
            })
        ]
    });
};
export { BannerTcfGroupList };
